<template>
	<div id="g_authen">
		<div class="g-right-top width800">个人中心 / 在线认证</div>
		<div class="g-right-middle width800  margintop20">
			<center style="margin-top: 30px;">
				<Icon type="logo-vimeo" /><span style="margin-left:10px;font-weight: bold;">{{card}}</span></center>

			<div class="sfzfm">
				<img :src="imgsrc1" width="366" height="230">
				<input class="sfzupfm" type="file" name="image" @change="addpic1($event)">

			</div>
			<center>身份证正面</center>



			<div class="sfzfm">
				<img :src="imgsrc2" width="366" height="230">
				<input class="sfzupfm" type="file" name="image" @change="addpic2($event)">
			</div>
			<center>身份证背面</center>
			<div class="sfzfm2">
				<img :src="imgsrc3" width="366" height="450">
				<input class="sfzupfm2" type="file" name="image" @change="addpic3($event)">
			</div>
			<center>手持身份证</center>


			<!-- <div class="clearfix"></div> -->

			<center>
				<el-button type="success" class='new_authen' style="text-align: center;margin: 40px 0;" @click='upinfor'>提交审核</el-button>
			</center>
			<center>
				<el-button type="success" class='ing_authen' style="text-align: center;margin: 40px 0;" @click='m_authen'>修改</el-button>
			</center>



		</div>
	</div>
</template>

<script>
	import Axios from 'axios'
	import storage from '../../storage/storage.js'
	export default {
		data() {
			return {
				positive: '',
				back: '',
				card: '',
				imgsrc1: '',
				imgsrc2: '',
				imgsrc3: '',
				holdcard: ''
			};
		},
		methods: {
			addpic1(event) {
				this.positive = event.target.files[0]; //获取上传对象
				this.imgsrc1 = window.URL.createObjectURL(this.positive); //获取上传对象路径
				var reader = new FileReader();
				reader.readAsDataURL(this.positive);
				reader.onload = function(e) {
					this.positive = e.target.result; //转换图片对象为base64
					storage.set('positive', this.positive) //将base64信息存储用于下面提交事件
				}

			},
			addpic2(event) {
				this.back = event.target.files[0]; //获取上传对象
				this.imgsrc2 = window.URL.createObjectURL(this.back); //获取上传对象路径
				var reader = new FileReader();
				reader.readAsDataURL(this.back);
				reader.onload = function(e) {
					this.back = e.target.result; //转换图片对象为base64
					storage.set('back', this.back) //将base64信息存储用于下面提交事件
				}
			},
			addpic3(event) {
				this.holdcard = event.target.files[0]; //获取上传对象
				this.imgsrc3 = window.URL.createObjectURL(this.holdcard); //获取上传对象路径
				var reader = new FileReader();
				reader.readAsDataURL(this.holdcard);
				reader.onload = function(e) {
					this.holdcard = e.target.result; //转换图片对象为base64
					storage.set('holdcard', this.holdcard) //将base64信息存储用于下面提交事件
				}
			},
			getauthen() {
				var api = 'https://api.yopoo.cn/api/centre/updateauth'
				Axios.get(api, {
					header: storage.get('token')
				}).then((res) => {
					console.log(res)
					this.imgsrc1 = res.data.positive
					this.imgsrc2 = res.data.back
					this.imgsrc3 = res.data.holdcard
				})
			},
			m_authen() {
				var api = 'https://api.yopoo.cn/api/centre/updateauth'	//修改信息
				let infor = {
					positive: storage.get('positive'),
					back: storage.get('back'),
					holdcard:storage.get('holdcard')
				}
				Axios.post(api, infor).then((res) => {
					console.log(res)
					if (res.data.code == 200) {
						this.$message({ //提示返回信息
							message: res.data.msg,
							type: 'success',
							center: true
						});
					} else {
						this.$message({ //提示返回信息
							message: res.data.msg,
							type: 'error',
							center: true

						});
					}

				})
			},
			upinfor() {
				var api = 'https://api.yopoo.cn/api/centre/createcard'	//提交信息
				if (!this.positive && !this.back) {
					this.$message({ //提示返回信息
						message: '请上传身份证正反面',
						type: 'error',
						center: true
					});
				} else {
					let infor = {
						positive: storage.get('positive'),
						back: storage.get('back'),
						holdcard:storage.get('holdcard')
					}
					Axios.post(api, infor).then((res) => {
						// console.log(res)
						if (res.data.code == 200) {
							this.$message({ //提示返回信息
								message: res.data.msg,
								type: 'success',
								center: true
							});

							storage.set('card', '2') //本地存储提交后的状态
							this.card = '审核中'
							$(function() {

								$('.ing_authen').show()
								$('.new_authen').hide()
								$('.ivu-icon-logo-vimeo').css('color', "#ff5a61");
							})

						} else {
							this.$message({ //提示返回信息
								message: res.data.msg,
								type: 'error',
								center: true

							});
						}
					})
				}

			}
		},
		mounted() {
			this.getauthen()
			var c = storage.get('card')
			if (c == 3) {
				this.card = '已认证'
				$(function() {
					$('.new_authen').hide()
					$('.ing_authen').hide()
					$('.ivu-icon-logo-vimeo').css('color', "#c8b9a6");
				})
			}
			if (c == 2) {
				this.card = '审核中'
				$(function() {
					$('.new_authen').hide()
					$('.ivu-icon-logo-vimeo').css('color', "#ff5a61");
				})
			}
			if (c == 1) {
				this.card = '未认证'
				$(function() {
					$('.ing_authen').hide()
					$('.ivu-icon-logo-vimeo').css('color', "grey");
				})
			}
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/per_admin/P_Authen.vue